class logger {
  constructor(){
    this.typeMap = {
      info: {
        styles: {
          label: [
            'background-color: gray',
            'margin-right:10px',
            'padding: 2px 5px',
            'border-radius: 3px',
            'color: #fff',
            'font-weight: bold',
            'font-size: 9px'
          ],
          outline: [
            'color: gray'
          ],
          details: [
            'color: gray'
          ]
        }
      },
      try: {
        styles: {
          label: [
            'background-color: blue',
            'margin-right:10px',
            'padding: 2px 5px',
            'border-radius: 3px',
            'color: #fff',
            'font-weight: bold',
            'font-size: 9px'
          ],
          outline: [
            'color: blue',
            'font-weight: bold'
          ],
          details: [
            'color: blue'
          ]
        }
      },
      success: {
        styles: {
          label: [
            'background-color: green',
            'margin-right:10px',
            'padding: 2px 5px',
            'border-radius: 3px',
            'color: #fff',
            'font-weight: bold',
            'font-size: 9px'
          ],
          outline: [
            'color: green',
            'font-weight: bold'
          ],
          details: [
            'color: green'
          ]
        }
      },
      failure: {
        styles: {
          label: [
            'background-color: red',
            'margin-right:10px',
            'padding: 2px 5px',
            'border-radius: 3px',
            'color: #fff',
            'font-weight: bold',
            'font-size: 9px'
          ],
          outline: [
            'color: red',
            'font-weight: bold'
          ],
          details: [
            'color: red'
          ]
        }
      },
      weak: {
        styles: {
          label: [
            'background-color: silver',
            'margin-right:10px',
            'padding: 2px 5px',
            'border-radius: 3px',
            'color: #fff',
            'font-weight: bold',
            'font-size: 9px'
          ],
          outline: [
            'color: silver',
            'font-weight: bold'
          ],
        }
      },
    }
    for (const typeKey of Object.keys(this.typeMap)) {
      for (const styleKey of Object.keys(this.typeMap[typeKey].styles)) {
        this.typeMap[typeKey].styles[styleKey] = this.typeMap[typeKey].styles[styleKey].join(';')
      }
    }
  }

  info(...argv){
    if(!APP_ENV) return
    const type = 'info'
    console.info(
      `%c${type}%c${argv[0]}`,
      this.typeMap[type].styles.label,
      this.typeMap[type].styles.outline
    )
    argv.slice(1).forEach((item)=>{
      console.info(
        `%c${type}%c>>> ${item}`,
        this.typeMap[type].styles.label,
        this.typeMap[type].styles.details
      )
    })
  }
  try(...argv){
    if(!APP_ENV) return
    const type = 'try'
    console.info(
      `%c${type}%c${argv[0]}`,
      this.typeMap[type].styles.label,
      this.typeMap[type].styles.outline
    )
    argv.slice(1).forEach((item)=>{
      console.info(
        `%c${type}%c>>> ${item}`,
        this.typeMap[type].styles.label,
        this.typeMap[type].styles.details
      )
    })
  }
  success(...argv){
    if(!APP_ENV) return
    const type = 'success'
    console.info(
      `%c${type}%c${argv[0]}`,
      this.typeMap[type].styles.label,
      this.typeMap[type].styles.outline
    )
    argv.slice(1).forEach((item)=>{
      console.info(
        `%c${type}%c>>> ${item}`,
        this.typeMap[type].styles.label,
        this.typeMap[type].styles.details
      )
    })
  }
  failure(...argv){
    if(!APP_ENV) return
    const type = 'success'
    console.info(
      `%c${type}%c${argv[0]}`,
      this.typeMap[type].styles.label,
      this.typeMap[type].styles.outline
    )
    argv.slice(1).forEach((item)=>{
      console.info(
        `%c${type}%c>>> ${item}`,
        this.typeMap[type].styles.label,
        this.typeMap[type].styles.details
      )
    })
  }
  weak(...argv){
    if(!APP_ENV) return
    const type = 'weak'
    console.info(
      `%c${type}%c${argv[0]}`,
      this.typeMap[type].styles.label,
      this.typeMap[type].styles.outline
    )
  }
}
window.$logger = new logger()
